var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeHide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m2.731 11.78-.108.22.108.22a10.321 10.321 0 0 0 18.538 0l.108-.22-.108-.22a10.32 10.32 0 0 0-18.538 0zM12 9.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5zM12 5c4.717 0 8.758 2.891 10.46 7-1.702 4.11-5.743 7-10.46 7-4.717 0-8.758-2.89-10.46-7C3.241 7.891 7.282 5 12 5z",
    fill: "#C5C5C5",
    stroke: "#C5C5C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 3 L21 21",
    stroke: "#C5C5C5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeHide);
export default __webpack_public_path__ + "static/media/eyeHide.b4b1ad7f7fed7c6c3246163dd2ba139f.svg";
export { ForwardRef as ReactComponent };